export const linkResolver = doc => {
  return "/"
}
